<template>
    <div v-click-outside="cancelSearch">
        <div class="gs-finder-container">
            <v-icon size="17" color="#acacac" v-on:click="showSearch">search</v-icon>
        </div>
        <div
            class="gs-result-content"
            v-show="showSearchInput"
        >
            <div class="gs-post-list-control">
                <input ref="inputSearch"
                       type="text"
                       class="gs-finder-input"
                       v-model="searchText"
                       placeholder=Buscar
                       autofocus
                       @keyup.esc="cancelSearch"
                >
                <div class="right-button">
                    <v-icon v-show="!loading" v-on:click="cancelSearch" size="17" color="#acacac">close</v-icon>
                    <v-progress-circular
                        v-show="loading"
                        :indeterminate="loading"
                        :size="16"
                        :width="2"
                        color="#acacac"
                    ></v-progress-circular>
                </div>

            </div>

            <div class="gs-post-list-container"
                 v-if="posts.length > 0"
            >
                <template v-for="(post, index) in posts">
                    <div class="gs-post-list-item"
                         v-on:click="goToPost(post)"
                    >
                        <img class="gs-post-list-item-img" :src="post.thumbnail_base_64" alt="">
                        <div class="gs-post-list-item-title" v-html="post.title"></div>
                        <div class="gs-post-list-item-preview" v-html="post.preview"></div>
                        <label class="gs-post-list-item-author">
                            <img class="gs-post-list-item-author-img" :src="post.author.src" alt="">
                            <strong>{{ post.expositor.last_name }}</strong> {{ post.expositor.first_name }}
                        </label>
                        <label class="gs-post-list-item-date" v-html="post.date"></label>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {EventBus} from '../../js/bus'
    import axios from 'axios/index'
    import vClickOutside from 'v-click-outside'
    import _ from 'lodash'

    export default {
        data: () => {
            return {
                loading: false,
                showSearchInput: false,
                searchText: '',
                posts:[],
                pagination:{}
            }
        },
        mounted() {
            EventBus.$on('cancel-search', () => {
                this.cancelSearch();
            })
        },
        directives: {
            clickOutside: vClickOutside.directive
        },
        methods: {
            onBlur: function() {
                this.$emit('onBlur');
                this.cancelSearch();
            },
            goToPost: function(post) {
                window.document.location.href = post.link;
            },
            showSearch: function() {
                this.showSearchInput = true
                this.$nextTick(() => {
                    this.$refs.inputSearch.focus()
                })
            },
            cancelSearch: function() {
                this.showSearchInput = false
                this.searchText = ''
                this.posts = []
            },
            search: function() {
                if ( _.trim(this.searchText) == '' ){
                    this.loading = false
                    this.posts = []
                    this.$emit('onResponse', []);
                    return
                }

                this.loading = true
                axios.post('/wp-json/gsapi/v1/search', {
                    text: this.searchText
                }).then( (response) => {
                    this.loading = false
                    if ( response.status == 200 ) {
                        this.$emit('onResponse', response.data.result);
                        this.posts = response.data.result;
                        this.pagination = response.data.pagination
                    }
                    else {
                        console.log(response);
                    }
                })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    });
            }
        },
        watch: {
            searchText: _.debounce(function(){
                this.loading = true
                this.search()
            }, 300)
        }
    }
</script>

<style lang="scss" scoped>

    .gs-finder-container {
        display: inline-block;
        font-family: Roboto, sans-serif;
        width: max-content;

    }

    .gs-result-content {

        position: fixed;
        z-index: 1;
        top: 110px;
        right: 30px;
        border: 1px solid #c7c7c7;
        border-radius: 5px;
        padding: 6px;
        background: white;
        -webkit-box-shadow: -1px 4px 12px -1px rgba(0,0,0,0.48);
        -moz-box-shadow: -1px 4px 12px -1px rgba(0,0,0,0.48);
        box-shadow: -1px 4px 12px -1px rgba(0,0,0,0.48);
        color: #383838;

        .gs-post-list-control {

            position: relative;
            padding-right: 31px;

            input.gs-finder-input {
                font-family: "Roboto", sans-serif;
                font-size: 13px;
                margin-left: 4px;
                padding: 5px 8px;
                width: 100%;
                border: 1px solid #c7c7c7;
                font-weight: normal;
            }

            .right-button {
                position: absolute;
                right: 2px;
                top: 5px;
                i.v-icon {
                    cursor: pointer;
                    font-size: 19px;
                    text-shadow: none;
                }

            }

        }

        .gs-post-list-container {
            height: 71vh;
            width: 70vw;
            overflow-y: scroll;
            margin-top: 7px;
            border-top: 1px solid rgba(185, 185, 185, 0.75);
            -webkit-box-shadow: inset 0px 27px 13px -30px rgba(0,0,0,0.75);
            -moz-box-shadow: inset 0px 27px 13px -30px rgba(0,0,0,0.75);
            box-shadow: inset 0px 27px 13px -30px rgba(0,0,0,0.75);
        }
    }

    .gs-post-list-item {

        cursor: pointer;
        position: relative;
        padding: 10px 8px 10px 181px;
        font-size: 13px;
        min-height: 106px;
        line-height: 13px;
        font-weight: 300;
        overflow: hidden;
        border-bottom: 1px solid #d6d6d6;

        &:hover {
            background: whitesmoke;
        }


        .gs-post-list-item-img {
            position: absolute;
            top: 7px;
            left: 6px;
            width: 165px;
        }

        .gs-post-list-item-title {
            font-size: 12px;
            font-family: Montserrat,sans-serif;
            font-weight: 600;
            padding-bottom: 6px;
            text-transform: none;
            text-shadow: none;
        }

        .gs-post-list-item-preview {
            font-family: "Roboto", sans-serif;
            text-transform: none;
            text-shadow: none;
        }

        .gs-post-list-item-author {

            position: absolute;
            bottom: 7px;
            right: 8px;
            font-family: "Roboto", sans-serif;
            font-size: 12px;
            padding: 6px 32px 6px 5px;
            background: #ffffff;
            border-radius: 22px;
            text-transform: none;
            text-shadow: none;

            img.gs-post-list-item-author-img {
                width: 25px;
                border-radius: 50px;
                position: absolute;
                right: 0px;
                top: 0px;
                border: 2px solid white;
            }

        }

        label.gs-post-list-item-date {
            position: absolute;
            bottom: 8px;
            left: 180px;
            font-size: 11px;
            font-family: "Roboto", sans-serif;
            color: #3d9fd0;
            font-weight: 400;
            padding: 4px 7px;
            background: #ffffff;
            border-radius: 22px;
            text-transform: none;
            text-shadow: none;
        }

    }

</style>
